import script from "./ComparisonModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparisonModal.vue?vue&type=script&setup=true&lang=js"

import "./ComparisonModal.vue?vue&type=style&index=0&id=68a2fbd2&lang=scss"

const __exports__ = script;

export default __exports__